import TableChart from "../../../../components/charts/tableChart";
import React from "react";
import {useLoggedInApi} from "../../../../api";
import {useQuery} from "react-query";

export default function TableNewLeads({filters}) {
    const api = useLoggedInApi()
    const query = useQuery(['properties', 'report', 'new_leads_by_group', filters], () => {
        const resource = api.resource('properties/groups')
        return resource.getItem('new_leads_by_group', {
            params: filters
        }).then(response => response.data)
    })

    return <TableChart
        isLoading={query.isLoading}
        rows={query.data?.map(row => ({
            label: row.property_groups__name, value: row.total
        }))}
        maxVisible={5}
        title={"NEW LEADS"}
        headers={["PROPERTY GROUP", "COUNT"]}
        total={1000}/>
}